import axiosOverlay from '../../js/axiosOverlay'

const state = {
    types: null,
    selectedType: null,
    iCanWrite: [],
    iCantRead: []
};

const getters = {
    types: state => state.types,
    selectedType: state => state.selectedType,
    iCanWrite: state => state.iCanWrite,
    iCantRead: state => state.iCantRead,
    getTypeById: (state) => (typeID) => {
        return JSON.parse(state.types)?.find(type => type.id === typeID) ?? null
    },
    getMyType: (state, getters, rootState, rootGetters) => {
        let myType = []
        let allType = JSON.parse(state.types)
        if (allType) {
            allType.forEach(function(type) {
                let flag = true
                if (type.roleFiltresWrite != null) {
                    rootGetters['user/getRoles'].forEach(function (role) {
                        if (type.roleFiltresWrite.includes(role)) {
                            flag = false
                        }
                    });
                }
                if (flag){
                    myType.push(type)
                }
            });
        }
        return myType
    }
};

const mutations = {
    SET_TYPES(state, types) {
        state.types = types;
    },
    SET_SELECTED_TYPE(state, type) {
        state.selectedType = type;
    },
    SET_I_CAN_WRITE(state, list) {
        state.iCanWrite = list;
    },
    SET_I_CANT_READ(state, list) {
        state.iCantRead = list;
    }
};

const actions = {
    async loadTypesFromAPI({ commit, state, rootGetters }) {
        if (state.types == null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/sollicitation/types",
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_TYPES', result);

                let iCanWrite = [];
                let iCantRead = [];
                let allType = JSON.parse(result);
                
                allType.forEach(function (type) {
                    // Remplissage de ce que je peux écrire
                    let flagWrite = true;
                    if (type.roleFiltresWrite != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (type.roleFiltresWrite.includes(role)){
                                flagWrite = false;
                            }
                        });
                    }
                    if (flagWrite) {
                        iCanWrite.push(type);
                    }

                    // Remplissage de ce que je peux lire
                    let flagRead = true;
                    if (type.roleFiltresRead != null) {
                        rootGetters['user/getRoles'].forEach(function (role) {
                            if (type.roleFiltresRead.includes(role)){
                                flagRead = false;
                            }
                        });
                    }
                    if (!flagRead) {
                        iCantRead.push(type);
                    }
                });
                
                commit('SET_I_CAN_WRITE', iCanWrite);
                commit('SET_I_CANT_READ', iCantRead);
                
            } catch (error) {
                console.log(error);
            }
        }
    },
    
    setSelectedType({ commit }, type) {
        commit('SET_SELECTED_TYPE', type);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
